import bee from "./Bee"
export default {
    name: "Advert",
    /*
        var query = {
            page: "",
            section: "",
            number_of_ads_to_load: ""
        }
    */
    /* eslint-disable no-unused-vars */
    load_adverts(query, success, fail) {
        bee.get({
            adverts: {
                _pg: query.number_of_ads_to_load,
                _w: [
                    [
                        [
                            ["platform", "e", "web_app"],
                            "AND",
                            ["page", "e", query.page]
                        ],
                        "AND",
                        ["section", "e", query.section]
                    ]
                ]
            }
        })
            .then(res => {
                if (success) {
                    var adds = res.adverts;
                    //nyd
                    //delete these dummy adds untill when admin can manage ads
                    // adds = [{
                    //     id: 1,
                    //     media_url:
                    //         "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600834572/botswana%20services/adverts/left_ads/slider_4_hnhms1.gif",
                    //     media_type: "image",
                    //     height: 400,
                    //     width: 300,
                    //     views_count: 0,
                    //     company_id: 34,
                    //     navigation_url: "https://youtube.com"
                    // },
                    // {
                    //     id: 2,
                    //     media_url:
                    //         "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600837722/botswana%20services/adverts/left_ads/slider_2_eyhoox.jpg",
                    //     media_type: "image",
                    //     height: 400,
                    //     width: 300,
                    //     views_count: 0,
                    //     company_id: 54,
                    //     navigation_url: "https://live.com"
                    // },
                    // {
                    //     id: 3,
                    //     media_url:
                    //         "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601451573/botswana%20services/adverts/left_ads/ad_skin_care_nngw9o.jpg",
                    //     media_type: "image",
                    //     height: 400,
                    //     width: 300,
                    //     views_count: 0,
                    //     company_id: 54,
                    //     navigation_url: "https://google.com"
                    // }];
                    //update the number of views of these adverts
                    var update_query = {
                        adverts: []
                    };
                    for (var index = 0; index < adds.length; index++) {
                        var ad = adds[index];
                        update_query.adverts.push({
                            views_count: parseInt(ad.views_count) + 1,
                            _w: [
                                ["id", "e", ad.id]
                            ]
                        });
                    }
                    if (update_query.adverts.length > 0) {
                        //we have some updates to push
                        bee.update(update_query).then(res2 => {
                            success(adds);
                        }).catch(errors2 => {
                            if (fail) {
                                fail(errors2);
                            }
                        });
                    } else {
                        success(adds);
                    }
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            id: 0,
            page: "",
            section: "",
            user_id: 0,
            views_count: 0
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_advert(query, success, fail) {
        bee.post({
            _julz: {
                _posts: [{
                    advert_click: {
                        advert_id: query.id,
                        user_id: query.user_id,
                        page: query.page,
                        section: query.section,
                        clicked_on: "1989-01-01",
                        _time_clicked_on_on_timestamp: "1989-01-01"
                    }
                }],
                _updates: [{
                    advert: {
                        views_count: parseInt(query.views_count) + 1,
                        _w: [
                            ["id", "e", query.id]
                        ]
                    }
                }]
            }
        }).then(res => {
            //console.log("This is it ", res);
            if (success) {
                success(res.julz.posts[0].advert_click);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    post_advert(query, success, fail) {
        bee
            .que()
            .get({
                featured_promotions: {
                    _w: [
                        [
                            [
                                ["platform", "e", query.platform],
                                "AND",
                                ["page", "e", query.page]
                            ],
                            "AND",
                            ["section", "e", query.section]
                        ]
                    ]
                },
                adverts: {
                    _w: [
                        [
                            [
                                ["platform", "e", query.platform],
                                "AND",
                                ["page", "e", query.page]
                            ],
                            "AND",
                            ["section", "e", query.section]
                        ]
                    ]
                }
            }, "check_section_taken")
            .post({

            }, "post_advert")
            .before("post_advert", (index, previous_res, tasks) => {
                if (parseInt(previous_res.featured_promotions.length) > 0) {
                    return "skip";
                } else if (parseInt(previous_res.adverts.length) > 0) {
                    return "skip";
                }
                return {
                    advert: {
                        ...query,
                        user_id: 0,
                        views_count: 0,
                        clicks_count: 0,
                        date_to_expire: "1989-01-01",
                        _time_date_to_expire_timestamp: "1989-01-01",
                        date_expired: "1989-01-01",
                        _time_date_expired_timestamp: "1989-01-01",
                        _date_date_posted: "",
                        _now_date_posted_timestamp: "",
                    }
                };
            })
            .send()
            .then(res => {
                // console.log("res" , res);
                if (res[1].response._skipped && res[1].response._skipped == true) {
                    if (fail) {
                        fail(["This site section is already assigned to a promotion or advert"]);
                        return;
                    }
                }
                if (success) {
                    success(res[1].response.advert);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_advert(query, success, fail) {
        bee.get({
            advert: {
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.advert);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_adverts(query, success, fail) {
        bee.get({
            adverts: {
            }
        })
            .then(res => {
                if (success) {
                    success(res.adverts);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    get_advert_details(query, success, fail) {
        bee.get({
            advert: {
                _w: [
                    ["id", "e", query.id]
                ]
            },
            advert_clicks: {
                _w: [
                    ["advert_id", "e", query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success({
                        ...res.advert,
                        advert_clicks: res.advert_clicks
                    });
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    update_advert(query, success, fail) {
        bee
            .que()
            .get({
                featured_promotions: {
                    _w: [
                        [
                            [
                                ["platform", "e", query.data.platform],
                                "AND",
                                ["page", "e", query.data.page]
                            ],
                            "AND",
                            ["section", "e", query.data.section]
                        ]
                    ]
                },
                adverts: {
                    _w: [
                        [
                            [
                                [
                                    ["platform", "e", query.data.platform],
                                    "AND",
                                    ["page", "e", query.data.page]
                                ],
                                "AND",
                                ["section", "e", query.data.section]
                            ],
                            "AND",
                            ["id", "ne", query.id]
                        ]
                    ]
                }
            }, "check_section_taken")
            .update({

            }, "update_advert")
            .before("update_advert", (index, previous_res, tasks) => {
                if (parseInt(previous_res.featured_promotions.length) > 0) {
                    return "skip";
                } else if (parseInt(previous_res.adverts.length) > 0) {
                    return "skip";
                }
                return {
                    advert: {
                        ...query.data,
                        _w: [
                            ["id", "e", query.id]
                        ]
                    }
                };
            })
            .send()
            .then(res => {
                // console.log("res" , res);
                if (res[1].response._skipped && res[1].response._skipped == true) {
                    if (fail) {
                        fail(["This site section is already assigned to either a promotion or advert"]);
                        return;
                    }
                }
                if (success) {
                    success(res[1].response.advert);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
}